import initState from "./state";

import {
  CLAIMANTS_ADDED,
  POLICY_ADDED,
  FR_SAVED,
  CLAIMENT_TABS_ADDED,
  PATH_ADDED,
  PAGE_MODE_ADDED,
  PAGE_ARGS_ADDED,
  MODAL_OPENED,
  PIP_BILLS_ADDED,
} from "./actionTypes";

const storeReducer = (state = initState, action) => {
  switch (action.type) {
    case MODAL_OPENED:
      return {
        ...state,
        visibleModalIndex: action.payload,
      };
    case PAGE_ARGS_ADDED:
      return {
        ...state,
        args: action.payload,
      };
    case PAGE_MODE_ADDED:
      return {
        ...state,
        pageMode: action.payload,
      };
      // case PIP_BILLS_ADDED:
      //   return {
      //     ...state,
      //     pipBills: action.payload,
      //   };
    case PATH_ADDED:
      return {
        ...state,
        pageType: action.payload,
      };
    case CLAIMANTS_ADDED:
      return {
        ...state,
        claimants: action.payload,
      };
    case CLAIMENT_TABS_ADDED:
      return {
        ...state,
        claimantTab: action.payload,
      };
    case POLICY_ADDED:
      return {
        ...state,
        policy: action.payload,
      };

    case FR_SAVED:
      return {
        ...state,
        policy: action.payload,
      };
    default:
      return state;
  }
};

export default storeReducer;
